var _a;
import { U as UniversalModal, c as createLinkFromTemplate, i as initAddToBag, a as cart, P as ProductConfigurables, p as productQty, b as productSwatches, d as ProductGallery } from "./product-config-BYVntl-u.js";
import { r as renderProductCardsFromHandles } from "./render-product-cards-C86dq60y.js";
const defaultSearchSpringProfileTag = "cross-sell";
const maxProducts = 2;
function completeTheLookSearchSpring(productId, profileTag) {
  function getRecommendedProducts() {
    const ctlContainer = document.getElementById("pdp-complete-the-look");
    if (!profileTag) {
      profileTag = defaultSearchSpringProfileTag;
    }
    const ssURL = `https://${SDG.Data.ssId}.a.searchspring.io/boost/${SDG.Data.ssId}/recommend?tags=${profileTag}&product=${productId}&limits=${maxProducts}`;
    fetch(ssURL).then((res) => res.json()).then((data) => {
      const ssData = data[0].results;
      if (ssData.length) {
        ssData.forEach((item) => {
          if (item.attributes.images.length >= 1) {
            let img1 = item.attributes.images[0];
            img1 = img1.replace(/\.(?=[^.]*$)/, "_504x600.");
            const $card = document.createElement("div");
            $card.classList.add("basis-1/2");
            $card.innerHTML = `
                <a href="${item.mappings.core.url}">
                  <div class="">
                    <img class="lazyload" data-src="${img1}" alt="${item.mappings.core.name} Featured Image" data-handle="${item.attributes.handle}">
                  </div>
                  <div class="mt-12">
                    <h3 class="redesign-body-6 text-charcoal-100" data-handle="${item.attributes.handle}">${item.mappings.core.name}</h3>
                  </div>
                </a>
              `;
            ctlContainer.appendChild($card);
          }
        });
      }
    }).catch((error) => {
      console.warn("Error fetching SearchSpring Complete The Look product data:", { error });
    });
    return ctlContainer;
  }
  function init() {
    getRecommendedProducts();
  }
  return init();
}
function productSizeChart($productSection) {
  const btn_sizeChartModal = $productSection.querySelector(".js-open-modal-size-chart");
  if (btn_sizeChartModal) {
    new UniversalModal(".modal-pdp-size-chart", ".js-open-modal-size-chart", "#close-sizeChart-modal");
  }
  const term = "Furniture Size Chart";
  const matchPattern = `[[${term}]]`;
  const accMenus = $productSection.querySelectorAll(".js-acc-menu");
  accMenus.forEach((menu) => {
    const descendants = menu.querySelectorAll("*");
    descendants.forEach((el) => {
      if (el.childNodes && el.childNodes.length) {
        el.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE && node.nodeValue.includes(matchPattern)) {
            const linkHTML = createLinkFromTemplate("gt-light-12-dark-line-grow", {
              text: term,
              url: "#",
              additionalClasses: "js-open-modal-size-chart"
            });
            const wrapper = document.createElement("span");
            wrapper.innerHTML = node.nodeValue.replace(matchPattern, linkHTML);
            el.replaceChild(wrapper, node);
            new UniversalModal(".modal-pdp-size-chart", ".js-open-modal-size-chart", "#close-sizeChart-modal");
          }
        });
      }
    });
  });
}
function productDimensionsChart($productSection) {
  const btn_productDimensionsChart = $productSection.querySelector(".js-open-modal-product-dimensions");
  if (btn_productDimensionsChart) {
    new UniversalModal(".modal-pdp-product-dimensions-chart", ".js-open-modal-product-dimensions", "#close-productDimensionsChart-modal");
  }
}
class DisplayRecentlyViewed {
  constructor() {
    this.containers = Array.from(document.querySelectorAll(".js-load-recently-viewed"));
  }
  init() {
    const minItems = 1;
    const maxToShow = 4;
    if (!this.containers.length) return;
    const productData = this.getRecentlyViewedProducts();
    if (!productData.length) {
      this.containers.forEach((container) => {
        _JK.helpers.addClass(container.parentElement, "hidden");
      });
      return;
    }
    const currentProductHandle = window.location.pathname.split("/").pop();
    let items = productData.map((item) => ({
      ...item,
      requires_gate: this.toBoolean(item.requires_gate)
    })).filter((item) => item.handle !== currentProductHandle);
    if (items.length < minItems) {
      this.containers.forEach((container) => {
        container.parentElement.classList.add("hidden");
      });
      return;
    }
    const handlesToRender = items.slice(0, maxToShow).map((item) => item.handle);
    this.containers.forEach((container) => {
      var _a2, _b, _c;
      const defaultCardClasses = ["basis-[calc(50%-4px)]", "lg:basis-1/4"];
      const customCardClasses = (_a2 = container == null ? void 0 : container.dataset) == null ? void 0 : _a2.cardClasses;
      const cardClasses = customCardClasses ? customCardClasses.split("|").map((className) => className.trim()).filter(Boolean) : defaultCardClasses;
      const cardView = ((_c = (_b = container == null ? void 0 : container.dataset) == null ? void 0 : _b.cardView) == null ? void 0 : _c.trim()) || "get-product-card";
      renderProductCardsFromHandles(handlesToRender, container, {
        view: cardView,
        cardClasses
      });
    });
  }
  getRecentlyViewedProducts() {
    const productData = JSON.parse(localStorage.getItem("recently-viewed"));
    return Array.isArray(productData) ? productData : [];
  }
  toBoolean(value) {
    if (typeof value === "boolean") return value;
    if (typeof value === "string") return value.toLowerCase() === "true";
    return Boolean(value);
  }
}
function productDescriptionFormatter() {
  var _a2;
  const panel = document.getElementById("acc-panel-1");
  const itemTitle = (_a2 = document.querySelector(".js-title")) == null ? void 0 : _a2.textContent.trim();
  for (let child of panel.childNodes) {
    if (child.nodeType === Node.ELEMENT_NODE || child.nodeType === Node.TEXT_NODE) {
      const text = child.textContent.trim();
      if (text.startsWith(itemTitle)) {
        if (child.nodeType === Node.ELEMENT_NODE) {
          child.classList.add("hidden");
        } else {
          const span = document.createElement("span");
          span.className = "hidden";
          span.textContent = text;
          panel.replaceChild(span, child);
        }
        break;
      }
    }
  }
}
try {
  const ShopifyTemplate = ((_a = _JK == null ? void 0 : _JK.config) == null ? void 0 : _a.template) || "";
  const isProductPage = ShopifyTemplate.includes("product");
  const accordionEl = document.getElementById("product-details-accordion");
  if (accordionEl) {
    const accordion = SDG.accordion({
      dom: {
        btn: "js-acc-btn",
        id: "product-details-accordion",
        menu: "js-acc-menu"
      },
      open_option: 0,
      type: "toggle"
    });
    accordion.init();
    const descPanel = accordionEl.querySelector("#acc-panel-1");
    if (descPanel.getAttribute("data-reformat-description") === "true") {
      productDescriptionFormatter();
    }
  }
  const $productForm = document.getElementById("addToBagForm");
  const $productSection = document.getElementById("product");
  if ($productForm && $productSection) {
    if (isProductPage) {
      initAddToBag(cart);
    }
    const productConfigurables = new ProductConfigurables({
      productForm: $productForm,
      productSection: $productSection
    });
    productConfigurables.init();
    productDimensionsChart($productSection);
    productSizeChart($productSection);
    productQty(document, $productForm);
    productSwatches();
  } else {
    console.warn("[product.js] Product form or section not found. Skipping configurable initialization.");
  }
  const mainGallery = document.querySelector("#gallery-carousel");
  const thumbsGallery = document.querySelector("#gallery-thumbs");
  if (mainGallery && thumbsGallery) {
    new ProductGallery("#gallery-carousel", "#gallery-thumbs");
  }
  const ctl = document.getElementById("pdp-complete-the-look");
  if (ctl && ctl.dataset.ctlSource === "SearchSpring") {
    completeTheLookSearchSpring(ctl.dataset.ctlProductId, ctl.dataset.ctlProfiletag);
  }
  const recentlyViewed = new DisplayRecentlyViewed();
  recentlyViewed.init();
} catch (err) {
  console.error("[product.js] Unexpected error initializing product page components:", err);
}
